import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { numberFormats } from '@/service/api/core/enums/currencyCode'

Vue.use(VueI18n)
// Do not refactor - it has to be 'ugly' to work with static require imports
function loadLocaleMessages() {
  const messages = {}

  const viniLocales = require.context('./locales-vini', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  viniLocales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = { ...messages[locale], ...viniLocales(key) }
    }
  })
  return messages
}

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
  numberFormats,
})
